<template>
  <div class="advform ops-form-ft ops-tags-input">

    <!-- From element -->
    <div class="uk-grid-small" uk-grid>

      <!-- Header -->
      <div class="uk-container-expand">
        <span class="uk-label uk-margin-right">{{inputelement.chLibs}}</span>
        <div uk-form-custom="target: > * > span:first-child">
          <!-- Rendu conditionnel selon operatorGroup -->
          <select v-if="operatorGroup === 'CV'" v-model="selected" @change="changeType">
            <option value="CV">Egale à</option>
            <option value="CVLT">Inférieur à</option>
            <option value="CVGT">Superieur à</option>
          </select>
          <select v-else v-model="selected" @change="changeType">
            <option value="CH">Egale à</option>
            <option value="CHLT">Inférieur à</option>
            <option value="CHGT">Superieur à</option>
          </select>
          <button class="uk-button uk-button-default" type="button" tabindex="-1">
            <span></span>
            <span class="uk-margin-small-left" uk-icon="icon: chevron-down ; ratio: 0.5"></span>
          </button>
        </div>
        <div class="uk-float-right"></div>
      </div>
      <!-- END Header -->
      <div class="uk-inline uk-width-expand@m">
        <vue-tags-input
          ref="tagsInput"
          v-model="tag"
          :tags="tags"
          :max-tags="1"
          :allow-edit-tags="true"
          :placeholder="tags.length === 0 ? inputelement.placeholder : ''"
          :add-on-key-press="tags.length === 0"
          @tags-changed="handleTagsChanged"
          @before-adding-tag="addAndOr"
          @before-deleting-tag="removeAndOr"
        >
          <template slot="tag-left" slot-scope="props">
            <span v-on:click="changeAndOr(props.index)" class="ops-select">{{ displayAndOr(props.index) }}</span>
          </template>
        </vue-tags-input>
      </div>

      <!-- DELETE BTN -->
      <div class="menu uk-width-auto@m">
        <i
          class="deleteFormCritere"
          @click="deleteFormCritere(inputelement)"
          uk-icon="icon: minus-circle; ratio: 1.5"></i>
      </div>

    </div>
    <!-- END From element -->

  </div>
</template>

<script>
import { VueTagsInput, createTags } from '@johmun/vue-tags-input'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { EventBus } from '../../main'

export default {
  name: 'InputAutoNumber',
  props: ['inputelement'],
  components: {
    VueTagsInput
  },
  data () {
    return {
      baseApiUrl: process.env.VUE_APP_TAG_API,
      envVar: process.env.VUE_APP_ENV,
      tag: '',
      tags: [],
      autocompleteItems: [],
      debounce: null,
      tagsOperator: [],
      tagJson: [],
      tempTagUrl: '',
      selected: this.inputelement.hasOwnProperty('chTypes') ? this.inputelement.chTypes : 'no',
      haveDataStorage: this.inputelement.hasOwnProperty('chValues') ? this.inputelement.chValues : '',
      hasJustAddedTag: false, // état pour gérer l'ajout de tags
      previousTags: [] // Pour comparer les modifications
    }
  },
  mounted () {
    const inputElement = this.$refs.tagsInput.$el.querySelector('input')
    if (inputElement) {
      inputElement.addEventListener('keyup', this.handleEnterKey)
    }
    if (this.haveDataStorage !== '') {
      if (Array.isArray(this.haveDataStorage)) {
        // console.log('#AKIDEBUG : haveDataStorage OK')
        this.haveDataStorage.forEach((value, index) => {
          // console.log('#AKIDEBUG : Insert = > Operator:', value.operator, ' / TAG: ', value.tag)
          // Operator
          this.tagsOperator.push(value.operator)
          this.tagJson.push({ operator: value.operator, tag: value.tag })
          // Value
          this.tags = [...this.tags, ...createTags([value.tag], ['ti-valid'])]
        })
      } else {
        /* Todo if load value ? */
        // console.log('#AKIDEBUG : haveDataStorage is not a array')
      }
    } else {
      // console.log('#AKIDEBUG : EMPTY haveDataStorage on TextInput Mounted()')
    }
  },
  beforeDestroy () {
    const inputElement = this.$refs.tagsInput.$el.querySelector('input')
    if (inputElement) {
      inputElement.removeEventListener('keyup', this.handleEnterKey)
    }
  },
  computed: {
    operatorGroup () {
      const type = (this.selected || '').toString()
      if (/^CH/.test(type)) return 'CH'
      return 'CV'
    },
    filteredItems () {
      return this.autocompleteItems.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
    ...mapGetters(['getBaseUrl'])
  },
  watch: {
    'tag': 'initItems',
    'inputelement': 'updateTagsLoading'
  },
  methods: {
    ...mapActions([
      'emitSaveFieldValue',
      'emitCleanRequeteNode'
    ]),
    log: function (evt) {
      // Open Modal
      window.console.log(evt)
    },
    openOffCanvas (id) {
      UIkit.offcanvas('#offcanvas-iframe-' + id).show()
    },
    deleteFormCritere (element) {
      this.$emit('deleteCritere', element)
    },
    addAndOr (obj) {
      // Vérifier si un tag peut être ajouté
      if (this.tags.length >= 1) {
        return
      }
      const isHeure = this.inputelement.chFields === 'heure'
      const regexHeure = /^(?:[0-2]\d|3[0-6]):[0-5]\d:[0-5]\d$/
      const regexNumber = /^-?\d+(?:[.,]\d+)?$/

      let value = obj.tag.text.trim();

      if (isHeure) {
        if (/^\d{1,2}$/.test(value)) value = `${value.padStart(2,'0')}:00:00`
        else if (/^(?:[0-2]\d|3[0-6]):[0-5]\d$/.test(value)) value = `${value}:00`
        obj.tag.text = value
      }

      const isValid = (isHeure && regexHeure.test(value)) || (!isHeure && regexNumber.test(value));
      if (!isValid) {
        // alert(isHeure ? 'Format attendu : hh:mm:ss (00:00:00 à 36:59:59)' : 'Veuillez entrer un nombre valide')
        return
      }

      const operator = this.tagsOperator.length ? 'ou' : ''

      // Ajout du tag visuel
      obj.addTag()

      // Mise à jour du JSON
      this.tagsOperator.push(operator);
      this.tagJson.push({ operator, tag: value });
      this.$set(this.inputelement, 'chValues', this.tagJson)
      this.emitCleanRequeteNode(this.inputelement);
    },
    removeAndOr (obj) {
      this.tagsOperator.splice(obj.index, 1)
      this.$set(this.tagsOperator, 0, '')
      this.tagJson.splice(obj.index, 1)
      obj.deleteTag()
      // SAVE
      this.$set(this.inputelement, 'chValues', this.tagJson)
      // EXPORT SEND
      this.emitCleanRequeteNode(this.inputelement)
    },
    changeAndOr: function (index) {
      var operator
      if (this.tagsOperator[index] === 'et') {
        operator = 'ou'
      } else if (this.tagsOperator[index] === 'ou') {
        operator = 'sf'
      } else {
        operator = 'et'
      }
      // var operator = (this.tagsOperator[index] == "et") ? 'ou' : 'et';
      this.$set(this.tagsOperator, index, operator) // update operator
      this.tagJson[index].operator = operator // update Json
    },
    displayAndOr: function (index) {
      return this.tagsOperator[index]
    },
    update (newTags) {
      this.autocompleteItems = []
      this.tags = newTags
    },
    handleTagsChanged (newTags) {
      // Même nombre de tags, donc potentiellement une modification || pas de previousTags si chargeé par import
      if (this.previousTags.length === 0 || (newTags.length === this.previousTags.length)) {
        newTags.forEach((tag, index) => {
          // Vérifie si le texte du tag a été modifié || pas de previousTags si chargeé par import
          if (this.previousTags.length === 0 || (this.previousTags[index] && tag.text !== this.previousTags[index].text)) {
            // Mettre à jour le tagJson et Émettre les mises à jour
            if (index < this.tagJson.length) {
              this.$set(this.tagJson, index, {
                ...this.tagJson[index],
                tag: tag.text
              })
              this.$set(this.inputelement, 'chValues', this.tagJson)
              this.emitCleanRequeteNode(this.inputelement)
            }
          }
        })
      }

      // Mettre à jour l'état des tags
      this.tags = newTags
      // Sauvegarder l'état pour la prochaine comparaison
      this.previousTags = JSON.parse(JSON.stringify(newTags))
    },
    updateTagsLoading () {
      // console.log('hello updateTagsLoading')
    },
    initItems () {
      // console.log('#AKIDEBUG : emitCleanRequeteNode')
      // EVERY KEYPRESS IN FORM INPUT
      if (this.tag.length < 2) return
      if (this.envVar === 'dev') {
        this.tempTagUrl = `https://itunes.apple.com/search?term=${this.tag}&entity=allArtist&attribute=allArtistTerm&limit=6&output=json`
      } else {
        this.tempTagUrl = this.getBaseUrl + `./empty.php?urlaction=chercheMotsSolr&output=json&type=${this.inputelement.autocomplete}&debut=${this.tag}`
      }
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        axios.get(this.tempTagUrl).then(response => {
          this.autocompleteItems = response.data.results.map(a => {
            if (this.envVar === 'dev') {
              return { text: a.artistName }
            } else {
              // Todo : ask label name
              return { text: a.option }
            }
          })
        }).catch((e) => console.warn('Oh. Something went wrong JSON !', e))
      }, 600)
    },
    handleEnterKey (event) {
      if (event.key === 'Enter') {
        if (this.hasJustAddedTag) {
          // Si l'utilisateur appuie sur Entrée une deuxième fois avec un champ vide
          if (this.tag === '') {
            // console.log('SEND');
            SKOPUS.ACTIONS.createSpinnerOverlay()
            this.$root.$emit('submit-form')
          }
        } else {
          // Lors de la première entrée, on attend que le tag soit ajouté
          // console.log('DONT SEND');
          this.hasJustAddedTag = true
        }
      }
    },
    changeType () {
      this.$set(this.inputelement, 'chTypes', this.selected)
      this.emitSaveFieldValue(this.inputelement)
    }
  }
}
</script>

<style lang="scss" scoped>

  .ops-tags-input .vue-tags-input {
    max-width: none;
  }

  .ops-tags-input .ti-input {
    padding: 2px 4px;
    min-height: 40px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
  }

  .ops-tags-input .ti-input .ti-tags {
    min-height: 40px;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark,
  .ops-tags-input .ti-tag {
    margin-left: 35px;
    background-color: #0186B1;
    padding: 5px 10px;
  }

  .ops-tags-input .ti-content {
    position: relative;
  }

  .ops-tags-input .ti-tag span {
    font-size: 14px;
    line-height: 14px;
  }

  .ops-tags-input .ti-tag-left {
    position: absolute;
    left: -40px;
    background-color: #D8D8D8;
    color: #4A4A4A;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
  }

  .ops-tags-input .ti-tag-left:hover {
    background-color: #cccccc;
  }

  .ops-tags-input .ti-tag.ti-tag.ti-invalid:first-child,
  .ops-tags-input .ti-tag.ti-tag.ti-deletion-mark:first-child,
  .ops-tags-input .ti-tag:first-child {
    margin-left: 0;
  }

  .ops-tags-input .ti-tag:first-child .ti-tag-left {
    display: none;
  }

  .et {
    background-color: #D8D8D8;
  }

  .ou {
    background-color: red;
  }

  .form-list-wrap .uk-label {
    display: inline-block;
    padding: 1px 10px;
    border-radius: 25px;
    text-decoration: none;
    color: #2D3C53;
    font-weight: 600;
    background: #ffffff;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
    margin: 5px 5px 7px 0;
    min-width: 100px;
  }

  .form-list-wrap .uk-button {
    display: inline-block;
    padding: 0 15px;
    border-radius: 25px;
    text-decoration: none;
    font-weight: 600;
    background: #E9E9E9;
    border: 1px solid #DFDFDF;
    color: #626D7E;
    height: 26px;
    line-height: 26px;
    transition: .4s;
    text-transform: none;
    font-size: 12px;
    line-height: 1;
  }

  .form-list-wrap .uk-button .ops-primary-color {
    color: #0186B1;
  }

  .ops-tags-input .menu {
    padding: 2px 0 0 15px;
    cursor: pointer;
  }

  .ops-tags-input .uk-form-icon {
    background-color: #075068;
    color: #ffffff;
  }

  .ops-tags-input .menu .uk-icon {
    color: #075068;
  }

  .ops-tags-input .menu .uk-icon:hover {
    color: red;
  }

  .ops-tags-input .inputoption {
    padding: 6px 10px; margin-left:15px;
    border-radius: 6px;
    border: 1px solid #B8DEE6;
    background: #CEEBF2;
    color:#3782AA;
    cursor: pointer;
    height:38px;
  }

  .deleteFormCritere {
    float: right;
  }

  .advform .uk-input {
    height: 40px;
    border: 1px solid #E9E9E9;
    border-radius: 6px;
    color: #222222;
    font-size: 12px;
  }

  .form-list-wrap .ti-selected-item {
    background-color: #0186B1;;
  }

  .form-list-wrap ul.list-group li.ti-new-tag-input-wrapper {
    /* contre ul li*/
    border: none;
    margin: 2px;
    padding: 3px 5px;
  }

  .ti-autocomplete {
    z-index: 2;
  }

  /* Modal iframe*/
  .advform .uk-grid-margin {
    margin-top: 0;
  }

  .uk-dropdown {
    padding: 0
  }

  /* Hide the inner input (caret) when at least one tag exists, like InputAutoDate */
  .ops-tags-input ::v-deep .ti-tags .ti-tag + .ti-new-tag-input-wrapper input {
    opacity: 0;
    pointer-events: none;
  }
</style>
<style>

  ti-input .ti-tags {
    min-height: auto;
    height: 40px !important;
  }

  .uk-offcanvas-bar {
    padding: 0; /* Remove padding if needed */
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensure the bar takes full height */
  }

  .iframe-full {
    flex: 1; /* Allow the iframe to take the remaining space */
    width: 100%;
    border: none;
  }
</style>
